import { ShieldCheck } from "lucide-react";

const CERTS = [
  { label: "Certified by Google", sub: "Google Business Verified" },
  { label: "Certified by Yelp", sub: "Yelp Verified Listing" },
  { label: "Certified by Angie's List", sub: "Angi Pro Network" },
];

export default function Certifications({ variant = "light" }) {
  const isDark = variant === "dark";
  return (
    <section
      data-testid="certifications-strip"
      className={`${isDark ? "bg-brand-obsidian text-brand-bone" : "bg-white border-y border-brand-line"} py-10`}
    >
      <div className="container-page">
        <div className="flex flex-col lg:flex-row lg:items-center gap-6 lg:gap-12">
          <div className="lg:w-1/4">
            <p className={`overline ${isDark ? "text-brand-olive" : ""}`}>Certified & verified</p>
            <h3 className={`font-heading text-2xl md:text-3xl font-bold tracking-tight mt-2 ${isDark ? "text-brand-bone" : "text-brand-ink"}`}>
              Trusted across the platforms homeowners actually use.
            </h3>
          </div>
          <div className="flex-1 grid grid-cols-1 sm:grid-cols-3 gap-4">
            {CERTS.map((c, i) => (
              <div
                key={i}
                data-testid={`cert-${i}`}
                className={`flex items-center gap-4 px-5 py-4 rounded-md border ${
                  isDark ? "bg-white/5 border-white/10" : "bg-brand-bone border-brand-line"
                }`}
              >
                <div className={`w-11 h-11 rounded-sm flex items-center justify-center shrink-0 ${
                  isDark ? "bg-brand-olive/20" : "bg-brand-limestone"
                }`}>
                  <ShieldCheck className={`w-5 h-5 ${isDark ? "text-brand-bone" : "text-brand-obsidian"}`} strokeWidth={1.75} />
                </div>
                <div className="min-w-0">
                  <p className={`font-heading font-bold leading-tight ${isDark ? "text-brand-bone" : "text-brand-ink"}`}>{c.label}</p>
                  <p className={`text-xs mt-0.5 ${isDark ? "text-brand-bone/60" : "text-brand-ash"}`}>{c.sub}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
